// extracted by mini-css-extract-plugin
module.exports = {"Emojify":"bbf_a bhe_g"};